
import React from 'react';
import { GridTable } from '@ctsu/ctsu-mui-grid';
import _ from 'lodash';
import { withAppContext } from '@ctsu/loader';
import { compose, withHandlers, withState } from 'recompose';
import { ValidatorForm } from 'components/FormHelpers/FormInputs';
import { openConfirmation } from 'helpers/Confirmation';
import { GetFromCtxValue, GetUserFullName, useGetPathProtocol } from 'helpers';
import { CanUserDeleteAgentsNonCtep } from 'appconstants/Permission';
import { httpStatusEnum , TE } from 'appconstants';
import EditINDAgents from './EditINDAgents';
import { INDAgentColumns } from '../gridcolumns';

let setEditingIndFlag;
const Indagents = ({
  state,
  setState,
  data,
  saveIndAgentInfo,
  agentValue,
  ctepAgents,
  protocolAgentGroup,
  cancelAgent
}) => {
  const RenderEditRow = (row, setEditing) => {
    if (_.isEmpty(state) && !_.isEqual(row, state)) {
      setState({ ...row });
    }

    setEditingIndFlag = (flg) => {
      setEditing(flg);
      setState({});
    };
    return (
      <EditINDAgents
        state={state || row}
        setEditing={setEditing}
        defaultRow={row}
        setState={setState}
        agentType={agentValue}
        ctepAgents={ctepAgents}
        protocolAgentGroup={protocolAgentGroup}
      />
    );
  };

  const onDelete = (row) => {
    cancelAgent(row.csaId, 'IND');
  };

  const saveIndAgents = () => {
    saveIndAgentInfo(state);
  };

  return (
    <ValidatorForm onSubmit={saveIndAgents}>
      <GridTable
        tag={`${TE.ID}nonctepstudyagents${TE.TABLE}`}
        title="Non-CTEP IND Holder Information"
        exportTitle={`Non-CTEP IND Holder Information-${useGetPathProtocol()}-Study Agents`}
        id="indAgents"
        columns={INDAgentColumns}
        user={GetUserFullName()}
        rows={data}
        editable
        editMode={CanUserDeleteAgentsNonCtep()}
        deletable={CanUserDeleteAgentsNonCtep()}
        allowAddRow
        filterable
        sortable
        enableToolbar
        renderEditRow={RenderEditRow}
        rowEditable={() => true}
        rowDeletable={() => true}
        onDelete={onDelete}
        recordPerPage={10}
        toPdf={false}
      />
    </ValidatorForm>
  );
};

const INDAgents = compose(
  withAppContext,
  withState('state', 'setState', {}),
  withHandlers({
    saveIndAgentInfo: props => postBody => {
      const {
        onSave, protocolId, context, agentLabel
      } = props;
      const confirmSave = () => {
        const postInfo = {
          ...postBody,
          indIdeType: agentLabel,
          prtId: protocolId,
          esysStatus: postBody.esysStatus || 'ACTIVE'
        };
        onSave(postInfo).subscribe(resp => {
          if (resp.status === httpStatusEnum.SUCCESS) {
            setEditingIndFlag(false);
          }
        });
      };
      openConfirmation({
        message: GetFromCtxValue(context, 'SAVE_IND_INFO_CONFIRM_TXT'),
        onAction: confirmSave,
        name: 'save_ind'
      });
    }
  })
)(Indagents);

export default INDAgents;
